// extracted by mini-css-extract-plugin
export default {"aigc_opt_writing":"AIGCOpt_aigc_opt_writing__9I7Ij","aigc_opt":"AIGCOpt_aigc_opt__UXpxo"};